import { LoadingStiModule } from 'src/app/_component/loading-sti/loading-sti.module';
import { BreadcrumbComponentModule } from '../../_component/breadcrumb/breadcrumb.module';
import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { IonicModule } from "@ionic/angular";
import { TranslateModule } from "@ngx-translate/core";
import { PaginationClientSideModule } from "src/app/app/_component/pagination-client-side/pagination-client-side.module";
import { SearchBarModule } from "src/app/app/_component/search-bar/search-bar.module";
import { HeaderModule } from "src/app/_component/header/header.module";
import { SharedDirectivesModule } from "src/app/_directives/shared-directives.module";
import { OrderPageRoutingModule } from "./order-provider-routing.module";
import { OrderProviderPage } from './order-provider.page';
import { NoResultModule } from '../../_component/no-result/no-result.module';


@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    OrderPageRoutingModule,
    TranslateModule,
    SharedDirectivesModule,
    HeaderModule,
    SearchBarModule,
    PaginationClientSideModule,
    BreadcrumbComponentModule,
    LoadingStiModule,
    NoResultModule,
  ],
  declarations: [OrderProviderPage],
})
export class OrderProviderPageModule {}
